import { Students } from './Students'

export default Students
